import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { OracleResponsysCopySource } from 'app/model/pipeline/copysource/oracle-responsys.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleResponsysCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class OracleResponsysCopySourceAdapter extends CopySourceAdapter<
    OracleResponsysCopySource,
    Model.ResponsysSource
> {
    protected override async _toResource(copySource: OracleResponsysCopySource): Promise<Model.ResponsysSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(OracleResponsysCopySource).name);
    }

    protected override async _toModel(
        resource: Model.ResponsysSource,
        copyActivity: CopyActivity
    ): Promise<OracleResponsysCopySource> {
        return this._toTabularModel(resource, copyActivity, OracleResponsysCopySource.MODEL);
    }
}
